/* OSO: format visible product copy without changing markup or commerce values. */
(() => {
  'use strict';
  const selector = '[data-oso-product-copy]';
  function formatText(text) {
    // Recover a serialized list only when the whole text node is valid JSON.
    const trimmed = text.trim();
    if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
      try {
        const values = JSON.parse(trimmed);
        if (Array.isArray(values) && values.every(value => ['string', 'number'].includes(typeof value))) {
          return text.replace(trimmed, values.map(value => formatText(String(value))).join(', '));
        }
      } catch (_) { /* Ordinary bracketed prose is handled below. */ }
    }
    return text
      .replace(/(\d)(?:["″“”＂]|'')/g, '$1 in')
      .replace(/["“”″＂]/g, '')
      .replace(/\b(\w+)\(s\)/g, '$1s')
      .replace(/[()[\]]/g, ' ')
      .replace(/(^|\s)[‘']([^‘’'\n]+)[’'](?=\s|[.,:;!?]|$)/g, '$1$2')
      .replace(/[^\S\r\n]{2,}/g, ' ')
      .replace(/ +([,.;:!?])/g, '$1');
  }
  function clean(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('script, style, textarea, pre, code, [contenteditable="true"]')) continue;
      const next = formatText(node.data);
      if (next !== node.data) node.data = next;
    }
  }
  function scan(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.parentElement?.closest(selector)) {
        const next = formatText(node.data);
        if (next !== node.data) node.data = next;
      }
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE && node.nodeType !== Node.DOCUMENT_NODE) return;
    if (node.nodeType === Node.ELEMENT_NODE && node.closest(selector)) clean(node);
    else node.querySelectorAll(selector).forEach(clean);
  }
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') scan(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
